export default {
  FILLED: 'btn-filled',
  OUTLINE: 'btn-outline',
  OPACITY: 'btn-opacity'
};
